<template>
  <div class="substep-spend-time-on-your-business">
    <div class="substep-header">
      <h3 data-testId="step-title">
        Spend time on your business, not in your business
      </h3>
      <p>
        See your team's time, activity, and proof of work at a glance, with a weekly report delivered to your inbox.
      </p>
    </div>
    <img
      :src="VSMB_GETTING_STARTED_SPEND_TIME_ON_BUSINESS_IMG"
      alt="Dashboard preview"
      class="substep-image"
    />
  </div>
</template>

<script>
import { VSMB_GETTING_STARTED_SPEND_TIME_ON_BUSINESS_IMG } from '~/rails_assets';

export default {
  name: 'SpendTimeOnYourBusiness',
  data: () => ({
    VSMB_GETTING_STARTED_SPEND_TIME_ON_BUSINESS_IMG,
  }),
  mounted() {
    this.$emit('completeSubstep');
  },
};
</script>
